import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getAnswersForQuestionsPpgLvl } from 'gqlQueries/promoScoreCard';
import { promoScoreCardExpendedTable } from 'parser/promoScoreCardParser';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { count } from 'console';

const errorMessage: string = 'Something went wrong!';

function useFetchScoreCardExpandedTable() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);

    const variablesRef = useRef<any>({});
    const { appConfig } = useContext(UserContext);
    const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const [
        fetchScoreCardExpanded,
        { data: scoreCardExpandedData, loading: scoreCardExpandedDataLoading, error: scoreCardExpandedDataError },
    ] = useLazyQuery(getAnswersForQuestionsPpgLvl, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getAnswersForQuestionsPpgLvl } = payload;
            //if data present parse it and data coming from table
            if (getAnswersForQuestionsPpgLvl && getAnswersForQuestionsPpgLvl?.data?.length > 0) {
                const parsedData = promoScoreCardExpendedTable(
                    getAnswersForQuestionsPpgLvl.data,
                    promoScoreCardConfig.promoType,
                    promoScoreCardConfig.promoExpandedViewTableSalesAndVolumeLabel,
                );

                let tempData: any[] | null = null;
                //if not equal it means call coming from infinite scroll
                if (commonConfig.offset !== variablesRef.current.offset && Array.isArray(data)) {
                    tempData = [...data, ...parsedData];
                } else tempData = [...parsedData];
                setData(tempData);
                setCount(getAnswersForQuestionsPpgLvl?.meta?.count || 0);
                return;
            }

            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
        setCount(0);
    }

    return {
        loading,
        error,
        data: data,
        setLoading,
        count,
        fetchScoreCardExpandedTable: (variables: any) => {
            variablesRef.current = variables.variables;
            if (variables.variables.offset === commonConfig.offset) {
                setData(null);
                setCount(0);
            }
            setLoading(true);
            setError(null);
            fetchScoreCardExpanded(variables);
        },
    };
}

export { useFetchScoreCardExpandedTable };
